
import { css } from 'lit';
export default css`
pc-insight-hero .heading-h2{
    height:25%;
    transition:height linear 0.4s;
    overflow:hidden;
  }
  pc-insight-hero [slot='nav']{
    display:flex;
    column-gap:1rem;
    align-items:center;
  }

pc-insight-hero[loaded='loaded'] .heading-h2{
    height:100%;
  }

pc-insight-hero div[slot='image']{
  height:100%;
  width:100%;
}

pc-insight-hero div[slot='image'] img{
    object-fit:cover;
  }

pc-insight-hero [slot='nav'] pc-logo{
  display:none;
}

@media print{

pc-insight-hero [slot='nav'] pc-logo{
    display:block;
    margin-left:-12px
}
  }
`;